import Joi from "joi";

const ItemSchema = Joi.object({
  itemName: Joi.string().trim().required().messages({
    "string.empty": "Item Name is required.",
  }),
  itemCode: Joi.string().trim().required().messages({
    "string.empty": "Item Code is required.",
  }),
  // HSNCode: Joi.string().trim().required().messages({
  //   "string.empty": "HSN Code is required.",
  // }),
  itemType: Joi.string().trim().required().messages({
    "string.empty": "Item Type is required.",
  }),
  company: Joi.string().trim().when('itemType', {
    is: 'Inventory',
    then: Joi.string().required().messages({
      "string.empty": "Company is required.",
    }),
    otherwise: Joi.string().optional()
  }),
  department: Joi.string().trim().required().messages({
    "string.empty": "Department is required.",
  }),
  category: Joi.string().trim().required().messages({
    "string.empty": "Category is required.",
  }),
  subCategory: Joi.string().trim().required().messages({
    "string.empty": "Subcategory is required.",
  }),
  manageType: Joi.string().trim().required().messages({
    "string.empty": "Manage Type is required.",
  }),
  // Pricing and status fields - required only if manageType is not "Non Inventory"
  purchaseUnit: Joi.string().trim().valid('number', 'pcs', 'bundle', 'packet', 'litre', 'kg').when('manageType', {
    is: 'Non Inventory',
    then: Joi.string().optional().allow('', null),
    otherwise: Joi.string().valid('number', 'pcs', 'bundle', 'packet', 'litre', 'kg').required().messages({
      "string.empty": "Purchase Unit is required.",
      "any.only": "Please select a valid purchase unit"
    })
  }),
  purchaseQuantity: Joi.number().when('manageType', {
    is: 'Non Inventory',
    then: Joi.number().optional().allow(''),
    otherwise: Joi.number().min(1).required().messages({
      "number.base": "Purchase Quantity must be a number.",
      "number.min": "Purchase Quantity must be at least 1.",
    })
  }),
  saleUnit: Joi.string().trim().valid('number', 'pcs', 'bundle', 'packet', 'litre', 'kg').when('manageType', {
    is: 'Non Inventory',
    then: Joi.string().optional().allow('', null),
    otherwise: Joi.string().valid('number', 'pcs', 'bundle', 'packet', 'litre', 'kg').required().messages({
      "string.empty": "Sale Unit is required.",
      "any.only": "Please select a valid sale unit"
    })
  }),
  saleQuantity: Joi.number().when('manageType', {
    is: 'Non Inventory',
    then: Joi.number().optional().allow(''),
    otherwise: Joi.number().min(1).required().messages({
      "number.base": "Sale Quantity must be a number.",
      "number.min": "Sale Quantity must be at least 1.",
    })
  }),
  claimRate: Joi.number().when('manageType', {
    is: 'Non Inventory',
    then: Joi.number().optional().allow(''),
    otherwise: Joi.number().required().messages({
      "number.base": "Claim Rate must be a number.",
    })
  }),
  discountLevel1: Joi.string().trim().allow('').when('manageType', {
    is: 'Non Inventory',
    then: Joi.string().optional().allow(''),
    otherwise: Joi.string().trim().allow('').messages({
      "string.base": "Discount Level 1 must be a string.",
    })
  }),
  discountLevel2: Joi.string().trim().allow('').when('manageType', {
    is: 'Non Inventory',
    then: Joi.string().optional().allow(''),
    otherwise: Joi.string().trim().allow('').messages({
      "string.base": "Discount Level 2 must be a string.",
    })
  }),
  normalRate: Joi.number().when('manageType', {
    is: 'Non Inventory',
    then: Joi.number().required().messages({
      "number.base": "Normal Rate must be a number.",
      "any.required": "Normal Rate is required for Non-Inventory items.",
    }),
    otherwise: Joi.number().required().messages({
      "number.base": "Normal Rate must be a number.",
    })
  }),
  minQty: Joi.number().when('manageType', {
    is: 'Non Inventory',
    then: Joi.number().optional().allow(''),
    otherwise: Joi.number().min(0).required().messages({
      "number.base": "Min Quantity must be a number.",
      "number.min": "Min Quantity cannot be negative.",
    })
  }),
  maxQty: Joi.number().when('manageType', {
    is: 'Non Inventory',
    then: Joi.number().optional().allow(''),
    otherwise: Joi.number().min(0).required().messages({
      "number.base": "Max Quantity must be a number.",
      "number.min": "Max Quantity cannot be negative.",
    })
  }),
  sellingType: Joi.string().trim().valid('Batch wise', 'Batch Serial No', 'None').when('manageType', {
    is: 'Non Inventory',
    then: Joi.string().optional().allow('', null),
    otherwise: Joi.string().valid('Batch wise', 'Batch Serial No', 'None').required().messages({
      "string.empty": "Selling Type is required.",
      "any.only": "Please select a valid selling type"
    })
  }),
  // usageType: Joi.string().trim().required().messages({
  //   "string.empty": "Usage Type is required.",
  // }),
  // CPTCode: Joi.string().trim().messages({
  //   "string.base": "CPT Code must be a string.",
  // }),
  location: Joi.string().trim().when('manageType', {
    is: 'Non Inventory',
    then: Joi.string().optional().allow('', null),
    otherwise: Joi.string().required().messages({
      "string.empty": "Location is required.",
    })
  }),
  // batchCode: Joi.string().trim().messages({
  //   "string.base": "Batch Code must be a string.",
  // }),
  // barcode: Joi.string().trim().messages({
  //   "string.base": "Barcode must be a string.",
  // }),
}).unknown(true);

export default ItemSchema;
